import { APIJobs } from '@platform/client';
import { EmailTabSection } from '../../components/EmailTabSection';

export const IntroEmailTabContent = ({ introId }: { introId: number }) => {
  const {
    data: emailData,
    isLoading,
    isError,
    isSuccess,
  } = APIJobs.useGetIntroductionEmailJobs(introId);

  return (
    <EmailTabSection
      data={emailData}
      isLoading={isLoading}
      isError={isError}
      isSuccess={isSuccess}
      recordType='matching'
    />
  );
};
